module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_7042.437672ce.png";